import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'

export class TrendingSearchFilterEntity {
  searchWord?: string
  channel?: ChannelMiniEntity
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
